export default {
    url: '',
    template: `
        <div class="heading01 type01">
            <h1>{{ 'skill.Skills' | translate }}</h1>
        </div>
        <ul class="tabs01 type01">
            <li>
                <a ui-sref="authorized.user.skill.list.skill()" ui-sref-opts="{ location: 'replace' }"
                   ng-class="{ active: vm.$state.includes('authorized.user.skill.list.skill') }" ui-sref-active="active">
                    {{ 'skill.skills management' | translate }}
                </a>
            </li>
            <li>
                <a ui-sref="authorized.user.skill.list.scale()" ui-sref-opts="{ location: 'replace' }"
                   ng-class="{ active: vm.$state.includes('authorized.user.skill.list.scale') }" ui-sref-active="active">
                   {{ 'skill.Skills scale management' | translate }}
                </a>
            </li>
        </ul>
        <ui-view></ui-view>
    `
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/user/skill/list/index.js